 const url = "https://fbc-stats-backend.fly.dev"
 //const url = "http://localhost:3000"

export default url;